import {Component, OnInit} from '@angular/core';
import {User, FilterSearch, Site} from 'app/models/support.model';
import {SupportService} from './support.service';
import {ModalService} from 'app/views/modal/base_modal.component';
import {TranslateService} from 'app/translate/translate.service';
import {LogsModalComponent} from './modals/logs.component';
import {SetPremiumTemplatesModalComponent} from './modals/set_premium_templates.component';
import {SetProModalComponent} from './modals/set_pro.component';
import {RestorePasswordModalComponent} from './modals/restore_password.component';
import {SetPasswordModalComponent} from './modals/set_password.component';
import {SetRoleModalComponent} from './modals/set_role.component';
import {SetUserBanModalComponent} from './modals/set_user_ban.component';
import {SetUnBanModalComponent} from './modals/set_unban.component';
import {RenewTrialModalComponent} from './modals/renew_trial.component';
import {SetSiteBlockModalComponent} from './modals/set_site_block.component';
import {SetSiteUnBlockModalComponent} from './modals/set_site_unblock.component';
import {AttachTariffModalComponent} from './modals/attach_tariff.component';
import {ChangeOwnerModalComponent} from './modals/change_owner.component';
import {ChangeTariffModalComponent} from './modals/change_tariff.component';
import {TransferInvoiceModalComponent} from './modals/transfer_invoice.component';
import {RemoveInvoiceModalComponent} from './modals/remove_invoice.component';
import {EditSiteModalComponent} from './modals/edit_site.component';
import {RenewTariffModalComponent} from './modals/renew_tariff.component';
import {RemoveSiteModalComponent} from './modals/remove_site.component';
import {ChangeLangModalComponent} from './modals/change_lang.component';
import {BreakPublishModalComponent} from './modals/break_publish.component';
import {SeoUberModalComponent} from 'app/support/support/modals/seo_uber.component';
import {SetFreemiumUserModalComponent} from './modals/set_freemium_user.component';
import {SetFreemiumSiteModalComponent} from './modals/set_freemium_site.component';
import {SetUberTariffModalComponent} from './modals/set_uber_tariff.component';
import {SetDivlyIdModalComponent} from './modals/set_divly_id.component';
import {SetExcludeFromStatsComponent} from './modals/set_exclude_from_stats';
import {ActivatedRoute, Router} from '@angular/router';
import { DatePipe } from '@angular/common';
import * as qs from 'qs';
import {getUtmList, getUTMhash, getSiteStatusStyle} from 'app/lib/lib';

import {PaidDetailsComponent} from 'app/views/modal/paid_details/paid_details.component';
import {ConfirmComponent} from '../../views/modal/confirm.component';
import {BanSitesByListModalComponent} from './modals/ban_sites_by_list.component';
import {CheckForDivlyModalComponent} from './modals/check_for_divly.component';
import {DateFormat} from '../../pipes/dateFormat.pipe';
import {RestoreSiteModalComponent} from './modals/restore_site.component';
import {EditRecurrentModalComponent} from './modals/edit_recurrent.component';
import {SetDivlyLabelModalComponent} from './modals/set_divly_label.component';
import {DisableRecurrentModalComponent} from './modals/disable_recurrent.component';
import {UserReRegInfoModalComponent} from './modals/rereg_modal.component';
import {ChangeCurrencyModalComponent} from "./modals/change_currency.component";
import {SiteHistoryModal} from "./modals/site_history_modal.component";
import {SetMultilangCloneModalComponent} from "./modals/set_multilang_clone.component";
import {CloneSiteModalComponent} from './modals/clone_site.component';
import {FixWidgetsModalComponent} from './modals/fix-widgets.component';
import {SiteFilesModalComponent} from './modals/site_files.component';

import {ReturnPaidComponent} from './modals/return_paid';
import {AlertComponent} from '../../views/modal/alert.component';
import {SitesService} from '../../sites/sites.service';
import { catchError, map, switchMap, tap, toArray, concatMap } from 'rxjs/operators';
import { from, Observable, of, Subscription } from "rxjs";
import { EventsService } from '../../lib/EventsService';
import { PromptComponent } from "../../views/modal/prompt.component";
import { NotificationsService } from "angular2-notifications";
import { HelperService } from "../../lib/helper.service";
import { BillingService2 } from "../../billing/billing.service";
import {DataProvider2} from "../../provider/data2.provider";
import { PromoputlModalComponent } from "./modals/promoputl.component";
import { AuthService } from "../../auth.service";

class SearchResult {
	userId: string;
	siteIdList: string[];
}


@Component({
	selector: 'app-support-component',
	templateUrl: './support.component.html',
	providers: [DatePipe, DateFormat]
})
export class SupportComponent implements OnInit {
	get billingButtonsActions(): string[] {
		return Object.keys(this.billingButtons);
	}
	public filters: string[] = ['site', 'email', 'username', 'invoiceNumber'];
	public filterSearch: FilterSearch = new FilterSearch();
	public typeFilter = 'email';
	public searchInProgress = false;
	public userInProgress = false;
	public sitesInProgress = false;
	private r = 456;

	public $s: Subscription;
	public $sitePagination: Subscription;
	public searchResult: SearchResult = new SearchResult();
	public user: User = null;
	public sites: Site[] = [];
	public apps: any[] = [];
	public utmList: string[] = getUtmList();
	public billingButtons: any = {
		ctfs: {
			text: 'support.support.change tariff',
			condition: {
				value: 'sitePaidStatus',
				equals: ['paid']
			},
			class: 'primary'
		},
		rifs: {
			text: 'support.support.extend tariff',
			condition: {
				value: 'sitePaidStatus',
				equals: ['paid']
			},
			class: 'info'
		},
		rtfs: {
			text: 'support.support.extend trial',
			condition: {
				value: 'sitePaidStatus',
				equals: ['trial', 'trialExpired', 'paidExpired']
			},
			class: 'primary'
		},
		atts: {
			text: 'support.support.apply tariff',
			condition: {
				value: 'sitePaidStatus',
				equals: ['trial', 'trialExpired', 'paidExpired']
			},
			class: 'success'
		},
		mits: {
			text: 'support.support.transfer payment',
			condition: {
				value: 'sitePaidStatus',
				equals: ['paid']
			},
			class: 'warning'
		},
		rsai: {
			text: 'support.support.disable tariff',
			condition: {
				value: 'sitePaidStatus',
				equals: ['paid']
			},
			class: 'danger'
		},
		return_paid: {
			text: 'support.support.return paid',
			condition: {
				value: 'sitePaidStatus',
				equals: ['paid']
			},
			class: 'danger'
		}
	};
	isCollapsedButtonNote = true;
	isCollapsedButtonsMore: boolean[] = [];
	isCollapsedSiteMap: boolean[] = [];

	public paidStatuses: any = {
		trialExpired: {i18n: this.translate.__A('support.support.trialExpired'), label: 'danger'},
		trial: {i18n: this.translate.__A('support.support.trial'), label: 'info'},
		paidExpired: {i18n: this.translate.__A('support.support.paidExpired'), label: 'danger'},
		paid: {i18n: this.translate.__A('support.support.paid'), label: 'success'},
		municipal: {i18n: 'Муниципальный', label: 'info'},
		promo: {i18n: 'Промо', label: 'info'},
	};

	public getUTMhash = getUTMhash;

	public getSiteStatusStyle = getSiteStatusStyle;
	
	public sitePageSize = 10;

	constructor(
		private supportService: SupportService,
		public activatedRoute: ActivatedRoute,
		public router: Router,
		private translate: TranslateService,
		private modalService: ModalService,
		private datePipe: DateFormat,
		public siteService: SitesService,
		private eventsService: EventsService,
		private notificationService: NotificationsService,
		public helperService: HelperService,
		public billingService: BillingService2,
		public dp2: DataProvider2,
		public authService: AuthService,
	) {

	}


	async ngOnInit() {
		const me = this;
		
		Object.keys(me.billingButtons).forEach((k) => {
			me.billingButtons[k].text = me.translate.__A(me.billingButtons[k].text);
		});
		
		me.activatedRoute.queryParams.subscribe(async (params: any) => {
			if (Object.keys(params).length > 0) {
				if (params.typeFilter) {
					me.typeFilter = params.typeFilter;
				}
				
				if (params.value) {
					me.filterSearch[me.typeFilter] = params.value;
				}

				if (params.accurateSiteSearch) {
					me.filterSearch.accurateSiteSearch = params.accurateSiteSearch == 'true';
				}

				if (params.r) {
					me.r = params.r;
				}

				if (params.cluster) {
					me.supportService.cluster = parseInt(params.cluster, 10);
				}
				
				await me.getData();
			}
		});
	}
	
	get totalSiteCount() {
		return this.searchResult.siteIdList.length;
	}
	
	public sitesOnPage: number = 0;
	
	async getData() {
		const me = this;
		
		if ( ! me.filterSearch[me.typeFilter]) {
			return ;
		}
		
		if (me.$s) {
			me.$s.unsubscribe();
			me.$s = null;
		}
		
		me.$s = of({
				value: me.filterSearch[me.typeFilter],
				typeFilter: me.typeFilter,
				accurateSiteSearch: me.filterSearch.accurateSiteSearch,
				sitePage: me.filterSearch.sitePage,
			})
			.pipe(
				tap(() => {
					me.clearData();
					me.searchInProgress = true;
				}),
				switchMap(({value, typeFilter, accurateSiteSearch}) => me.supportService.getSearchResult(
					value, typeFilter, accurateSiteSearch
				)),
				tap(() => me.searchInProgress = false),
				map(data => {
					if ( ! data) {
						throw new Error('not found');
					}
					
					me.searchResult.userId = data['userId'];
					me.searchResult.siteIdList = data['siteIdList'];
				}),
				tap(() => me.userInProgress = true),
				switchMap(() => me.supportService.getUserInfoByID(me.searchResult.userId)),
				tap(() => me.userInProgress = false),
				map(userInfo => {
					me.user = userInfo.user;
					me.isCollapsedButtonNote = !(me.user.note !== '');
					
					me.apps = userInfo['appDataList'];
				}),
				switchMap(() => me.fillSites(me.filterSearch.sitePage,  me.sitePageSize)),
				catchError(err => {
					me.clearData();
					
					me.eventsService.broadcast(
						'http-error',
						err
					);
					
					return of(err);
				})
			)
			.subscribe(() => console.log('support load end'));
	}


	clearData() {
		const me = this;
		
		me.searchInProgress = false;
		me.userInProgress   = false;
		me.sitesInProgress  = false;
		
		me.user  = null;
		
		me.sites = [];
		me.isCollapsedButtonsMore = [];
		me.isCollapsedSiteMap     = [];
		
		me.apps  = [];
	}


	public async applyFilter() {
		this.r++;
		
		let params = {
			value: encodeURIComponent(this.filterSearch[this.typeFilter]),
			typeFilter: this.typeFilter,
			accurateSiteSearch: this.filterSearch.accurateSiteSearch,
			r: this.r,
			cluster: this.supportService.cluster
		};
		
		params = qs.stringify(params, {encode: false});
		
		await this.router.navigateByUrl(`/support?${params}`, {relativeTo: this.activatedRoute});
	}


	resetFilter() {
		this.filterSearch = new FilterSearch();
	}


	setCluster(cluster) {
		this.supportService.cluster = cluster;
	}


	async runUserAction(action: string) {
		const me = this;
		const userId: string = this.user._id;
		
		if (action === 'sptu') {
			const detail = await this.supportService.getSptuDetail(userId).toPromise();
			
			this.modalService.open(SetPremiumTemplatesModalComponent, {
				title: this.user.email || this.user.username,
				userId: userId,
				templates: detail['premiumTemplates'],
				userTemplates: detail['userPremiumTemplates']
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'spu') {
			this.modalService.open(SetProModalComponent, {
				userId: userId,
				title: this.user.email || this.user.username,
				pro: this.user.pro
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'rup') {
			this.modalService.open(RestorePasswordModalComponent, {
				userId: userId,
				title: this.user.email || this.user.username
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'sup') {
			this.modalService.open(SetPasswordModalComponent, {
				userId: userId,
				title: this.user.email || this.user.username
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'setUserRole') {
			this.modalService.open(SetRoleModalComponent, {
				userId: userId,
				title: this.user.email || this.user.username,
				role: this.user.role,
				accessor: this.user.accessor,
				admin: this.user.admin
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'userBan' || action === 'userUnBan') {
			if (this.user.isBan) {
				this.modalService.open(SetUnBanModalComponent, {
					userId: userId,
					title: this.user.email || this.user.username,
					email: this.user.email
				}).result.then((result) => {
					if (result === 'OK') {
						me.applyFilter();
					}
				});
			} else {
				this.modalService.open(SetUserBanModalComponent, {
					userId: userId,
					title: this.user.email || this.user.username,
					email: this.user.email
				}).result.then((result) => {
					if (result === 'OK') {
						me.applyFilter();
					}
				});
			}
		} else if (action === 'sfu') {
			this.modalService.open(SetFreemiumUserModalComponent, {
				userId: userId,
				title: this.user.email || this.user.username,
				allowFreemium: this.user.allowFreemium
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'setDivlyId') {
			this.modalService.open(SetDivlyIdModalComponent, {
				title: this.user.email || this.user.username,
				userId: userId,
				divlyId: ''
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'showSupportLogs') {
			const modal = this.modalService.openEmpty(LogsModalComponent, {size: 'hg'});
			const logs = await this.supportService.getLogs(userId, '').toPromise();
			const data = {
				title: 'Support logs',
				stats: logs,
				type: 'user'
			};

			this.modalService.fillData(modal, data).result.then(() => {});
		} else if (action === 'showSupportActionLogs') {
			const modal = this.modalService.openEmpty(LogsModalComponent, {size: 'hg'});
			const logs = await this.supportService.getSupportActionLogs(userId, '').toPromise();
			const data = {
				title: 'Support Action logs',
				stats: logs,
				type: 'user'
			};

			this.modalService.fillData(modal, data).result.then(() => {});
		} else if (action === 'changeCurrency') {
			this.modalService.open(ChangeCurrencyModalComponent, {
				userId: userId,
				title: this.user.email || this.user.username,
				oldCurrency: this.user.currency
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'exclude_from_stats') {
			this.modalService.open(SetExcludeFromStatsComponent, {
				userId: userId,
				title: this.user.email || this.user.username,
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		}
	}


	async runSiteAction(action: string, siteId: string) {
		const me = this;
		
		const site = this.sites.find(s => s._id === siteId);
		
		if (action === 'rtfs') {
			const result = await this.modalService.open(RenewTrialModalComponent, {
				siteId: site._id,
				title: site.domainUrl,
				trialExpiration: site._trialExpiration ? site._trialExpiration : 0,
				dateTrialStart: this.datePipe.transform(site.dateTrialStart, 'YYYY-MM-DD')
			}).result;
			
			if (result === 'OK') {
				me.applyFilter();
			}
		} else if (action === 'siteBlock' || action === 'siteUnBlock') {
			if (site.isBlock) {
				const result = await this.modalService.open(SetSiteUnBlockModalComponent, {
					siteId: site._id,
					title: site.domainUrl,
					domainUrl: site.domainUrl,
					userEmail: this.user.email
				}).result;
				
				if (result === 'OK') {
					me.applyFilter();
				}
			} else {
				const result = await this.modalService.open(SetSiteBlockModalComponent, {
					siteId: site._id,
					title: site.domainUrl,
					domainUrl: site.domainUrl,
					userEmail: this.user.email
				}).result;
				
				if (result === 'OK') {
					me.applyFilter();
				}
			}
		} else if (action === 'atts') {
			const result = await this.modalService.open(AttachTariffModalComponent, {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				notFirstPayment: (site.paidType === 'paid')
			}).result;
			
			if (result === 'OK') {
				me.applyFilter();
			}
		} else if (action === 'chso') {
			const modal = this.modalService.openEmpty(ChangeOwnerModalComponent);
			const details = await this.supportService.getChsoDetail(siteId).toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				oldOwnerEmail: this.user.email,
				domains: details.domains,
				emails: details.emails,
			};
			
			this.modalService.fillData(modal, data).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'ctfs') {
			const modal = this.modalService.openEmpty(ChangeTariffModalComponent);
			const details = await this.supportService.getCtfsDetail(siteId, site.domainUrl).toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				invoiceNumber: details['invoiceNumber'],
				dateToFormatted: details['dateToFormatted'],
				tariffId: details['tariffId'],
				currency: details['userCurrency'],
				recurrentProfile: details['recurrentProfile'],
			};
			data['tariffs'] = await this.supportService.getTariffs(siteId).toPromise();
			data['i18nTariffs'] = this.supportService.i18nTariffs;
			this.modalService.fillData(modal, data).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'rifs') {
			const modal = this.modalService.openEmpty(RenewTariffModalComponent);
			const details = await this.supportService.getCtfsDetail(siteId, site.domainUrl).toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				invoiceNumber: details['invoiceNumber'],
				tariffId: details['tariffId'],
				dateTo: this.datePipe.transform(details['dateTo'], 'YYYY-MM-DD'),
				recurrentProfile: details['recurrentProfile'],
				minCustomDaysCount: site._paidExpiration ? -site._paidExpiration : -999,
			};
			
			this.modalService.fillData(modal, data).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'mits') {
			const modal = this.modalService.openEmpty(TransferInvoiceModalComponent);
			const details = await this.supportService.getMitsDetail(siteId, site.domainUrl).toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				tariffId: details['activeInvoice']['tariffId'],
				dateTo: details['activeInvoice']['dateTo'],
				invoiceNumber: details['activeInvoice']['invoiceNumber'],
				sites: details['sites'],
			};

			this.modalService.fillData(modal, data).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'rsai') {
			const modal = this.modalService.openEmpty(RemoveInvoiceModalComponent);
			const details = await this.supportService.getRsaiDetail(siteId, site.domainUrl).toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				tariffId: details['tariffId'],
				dateTo: details['dateTo'],
				invoiceNumber: details['invoiceNumber']
			};
			
			this.modalService.fillData(modal, data).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'editCategory') {
			const modal = this.modalService.openEmpty(EditSiteModalComponent, {size: 'hg'});
			const details = await this.supportService.checkSupportEdit(site._id).toPromise();
			const categories = await this.supportService.getSiteCategories().toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				categories: categories,
				category: details['category'],
				subject: details['subject'],
				lastEditUser: details['lastEditUser'],
				lastEditTime: details['lastEditTime'],
				preview: details['preview'],
			};
			
			this.modalService.fillData(modal, data);
			modal.componentInstance.calcSubcategories();
		} else if (action === 'siteBan') {
			this.modalService.open(RemoveSiteModalComponent, {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				userEmail: this.user.email
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'csl') {
			this.modalService.open(ChangeLangModalComponent, {
				siteId: site._id,
				userId: this.user._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'breakPublish') {
			this.modalService.open(BreakPublishModalComponent, {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl
			});
		} else if (action === 'seoUber') {
			this.modalService.open(SeoUberModalComponent, {
				title: site.domainUrl,
				siteId: siteId,
				action: (site.isSeoUber ? 'unset' : 'set')
			});
		} else if (action === 'sf') {
			this.modalService.open(SetFreemiumSiteModalComponent, {
				siteId: site._id,
				title: site.domainUrl,
				inFreemiumMode: site.inFreemiumMode
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'billingDetail') {
			const modal = this.modalService.openEmpty(PaidDetailsComponent, {size: 'hg'});

			const { stats } = await this.billingService.siteBilling.detail(
				{ siteIds: [site._id] }
			).toPromise();
			const data = {
				title: site.domainUrl,
				details: stats
			};

			this.modalService.fillData(modal, data);
		} else if (action === 'uberApply') {
			this.modalService.open(SetUberTariffModalComponent, {
				siteId: site._id,
				title: site.domainUrl,
				userId: this.user._id,
			});
		} else if (action === 'showSiteLogs') {
			const modal = this.modalService.openEmpty(LogsModalComponent, {size: 'hg'});
			const stats = await this.supportService.getSiteLogs(site._id).toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				stats: stats
			};

			this.modalService.fillData(modal, data);
		} else if (action === 'siteAndUserActivity') {
			this.modalService.open(ConfirmComponent, {
				title: site.domainUrl,
				message: 'Вы уверены, что хотите выгрузить данные по сайту и его владельцу?'
			}).result.then((isConfirmed: any) => {
				if (isConfirmed === true) {
					window.location.href = `${this.dp2.baseRoute}/support/negotiator/sites/${site._id}/activity`;
				}
			});
		} else if (action === 'fixWidgets') {
			this.modalService.open(FixWidgetsModalComponent, {
				siteId: site._id,
				title: site.domainUrl
			}).result.then((result) => {
				if (result && result !== 'cancel') {
					this.modalService.open(AlertComponent, {
						title: 'Результат',
						message: result
					});
				}
			});
		} else if (action === 'disableRecurrentProfile') {
			this.modalService.open(DisableRecurrentModalComponent, {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				recurrentProfiles: site.recurrentProfiles,
			}).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		}  else if (action === 'editRecurrent') {
			const modal = this.modalService.openEmpty(EditRecurrentModalComponent);
			const details = await this.supportService.getCtfsDetail(siteId, site.domainUrl).toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				amount: 5, // details['amount'] / 100.00,
				userCurrency: '$', // details['userCurrency'],
				rebillStartDate: this.datePipe.transform(details['dateTo'], 'YYYY-MM-DD'),
				recurrentProfile: details.recurrentProfile,
			};
			
			const result = await this.modalService.fillData(modal, data).result;
			
			if (result === 'OK') {
				me.applyFilter();
			}
		} else if (action === 'siteRestore') {
			const result = await this.modalService.open(RestoreSiteModalComponent, {
				title: site.domainUrl,
				siteId: siteId
			}).result;
			
			if (result === 'OK') {
				me.applyFilter();
			}
		} else if (action === 'setDivlyLabel') {
			const result = await this.modalService.open(SetDivlyLabelModalComponent, {
				title: site.domainUrl,
				siteId: siteId,
				action: (site.isUber ? 'unset' : 'set')
			}).result;
			
			if (result === 'OK') {
				me.applyFilter();
			}
		} else if (action === 'return_paid') {
			const transactions = await this.siteService.getTransactionByQuery(
				{ siteId }
			).toPromise();

			const modal = this.modalService.open(ReturnPaidComponent, {
				title: site.domainUrl,
				siteId: siteId,
				transactions: transactions
			});

			const form = modal.componentInstance.form;

			form.$beforeSubmit.subscribe(async cb => {
				let data = form.value;
				const transaction = transactions.find(c => c.transactionId == data.transactionId);
				data.url = site.techUrl;
				data.tariffId = transaction.tariffId;
				data.tariffVariant = transaction.tariffVariant;
				data.recurrentProfile = site.recurrentProfile;

				await me.supportService.refound(siteId, data).toPromise();
				await me.applyFilter();

				return cb();
			});
		} else if (action === 'showSiteHistory') {
			const modal = this.modalService.openEmpty(SiteHistoryModal, {size: 'hg'});
			const { stats } = await this.supportService.getSiteHistory(site._id).toPromise();
			const data = {
				siteId: site._id,
				title: site.domainUrl,
				stats: stats
			};
			
			this.modalService.fillData(modal, data);
		} else if (action === 'setMultilangClone') {
			const modal = this.modalService.openEmpty(SetMultilangCloneModalComponent);
			const details = await this.supportService.getSiblings(site.userId).toPromise();
			const siblings = details['siblings'];
			siblings.unshift({_id: '', url: '**Не Мультияз**'});
			const sites = <Site[]>siblings;

			const data = {
				siteId: site._id,
				title: site.domainUrl,
				domainUrl: site.domainUrl,
				multilangParentId: (!site.multilangParentId ? '' : site.multilangParentId),
				siblings: sites,
			};

			this.modalService.fillData(modal, data).result.then((result) => {
				if (result === 'OK') {
					me.applyFilter();
				}
			});
		} else if (action === 'siteClone') {
			const result = await this.modalService.open(CloneSiteModalComponent, {
				siteId: site._id,
				userId: this.user._id,
				url: site.domainUrl,
			}).result;

			if (result === 'OK') {
				me.applyFilter();
			}
		} else if (action === 'promopult') {
			const result = await this.modalService.open(PromoputlModalComponent, {
				title: 'Изменение баланса промопульта для сайта ' + site.domainUrl,
				site: site,
			}).result;

			if (result === 'OK') {
				me.applyFilter();
			}
		} else if (action === 'siteFiles') {
			this.modalService.open(SiteFilesModalComponent, {
				title: site.domainUrl,
				siteId: site._id,
			}, {size: 'lg'});
		}
	}


	async saveNote() {
		if (this.user.note.length > 0) {
			this.supportService.saveNote(this.user._id, this.user.note).toPromise();
		}
	}


	async banSitesByList() {
		this.modalService.open(BanSitesByListModalComponent, {	}).result.then(() => {});
	}


	async checkForDivly() {
		this.modalService.open(CheckForDivlyModalComponent, {	}).result.then(() => {});
	}


	getUTMData(mark: any): any[] {
		const utm = this.getUTMhash(mark);
		
		return this.utmList.reduce(function (arr, utmKey) {
			if (utm[utmKey]) {
				arr.push({key: utmKey, utm: utm[utmKey]});
			}
			
			return arr;
		}, []);
	}


	getSiteStatus(siteData) {
		let status = '';
		
		// желтый - фантоманые, недоделанные в визарде
		if (siteData.markForRemovalAt) {
			status = 'remove';
		} else if (siteData.status === -1) {
			status = 'before_constructor';
		} else if (siteData.status === 0) {
			status = 'switch_off';
		} else {
			
			// Если оплачен или включён на халяву
			if (siteData.paidType === 'paid' || siteData.paidType === 'trial' || siteData.inFreemiumMode) {
				
				// Если сайт опубликован
				if (siteData.datePublished) {
					status = 'work';
				} else {
					status = 'not published';
				}
			} else {
				status = 'expired';
			}
		}
		
		return status;
	}


	getAge(dt): number {
		const dtE = new Date().getTime();
		const dtS = new Date(dt).getTime();
		
		return parseInt(((dtE - dtS) / (24 * 3600 * 365.25 * 1000)).toString(), 10);
	}


	async showReRegInfo(user: User) {
		if (user.countReReg === 0) {
			return ;
		}
		
		const { users } = await this.supportService.getReregList(user._id).toPromise();
		
		await this.modalService.open(
			UserReRegInfoModalComponent,
			{
				title       : 'Список аккаунтов-перерег',
				currentUser : user,
				users
			},
			{size: 'hg'}
		).result;
	}
	
	
	async changeHardboundStatus(event) {
		const me = this;
		
		event.target.blur();
		event.preventDefault();
		
		const comment = await me.modalService.open(PromptComponent, {
			title: 'Комментарий!',
			question: 'Введите комментарий, не меньше 10 символов',
			message: ''
		}).result;
		
		if (comment === 'cancel') {
			me.user.hardbounce = ! me.user.hardbounce;
			
			return ;
		}
		
		if (comment.length < 10) {
			me.user.hardbounce = ! me.user.hardbounce;
			me.notificationService.info('Комментарий', 'Введите комментарий, не меньше 10 символов', {timeOut: 4000});

			return ;
		}

		await me.supportService.setUserHardbounce({
			userId: me.user._id,
			hardbounce: me.user.hardbounce,
			comment,
		}).toPromise();
	}
	
	
	onPageChange(page: number) {
		const me = this;
		
		me.filterSearch.sitePage = page;
		
		me.fillSites(this.filterSearch.sitePage, this.sitePageSize)
			.subscribe(() => {
				console.log('onPageChange', this.filterSearch.sitePage, this.sitePageSize);
			});
	}


	fillSites(page: number, pageSize: number): Observable<Site[]> {
		const me = this;

		if (me.$sitePagination) {
			me.$sitePagination.unsubscribe();
			me.$sitePagination = null;
		}
		
		me.sites = [];

		me.sitesInProgress = true;
		
		const offsetStart = (page - 1) * pageSize;
		const offsetEnd = offsetStart + pageSize;
		
		const siteIdList = me.searchResult.siteIdList.slice(offsetStart, offsetEnd);

		me.sitesOnPage = siteIdList.length;

		return from(siteIdList).pipe(
			concatMap(siteId => me.supportService.getSiteByID(siteId)),
			tap(() => me.isCollapsedButtonsMore.push(true) && me.isCollapsedSiteMap.push(true)),
			tap(site => {
				if (site) {
					site._source = me.supportService.cluster;
					me.sites.push(site);
				}
			}),
			toArray(),
			tap(() => me.sitesInProgress = false)
		);
	}
}
